import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  accordionContainer: {
    backgroundColor: colors.lightestGrey,
    borderRadius: 10,
    marginTop: 20,
    padding: 10,
  },
  accordionContentContainer: {
    borderColor: colors.placeholder,
    borderTopWidth: 1,
    marginVertical: 5,
    paddingHorizontal: 10,
  },
  accordionTitleContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  buttonContainer: { borderRadius: 20 },
  buttonText: { fontSize: 18 },
  calendarContainer: { alignItems: "center", flexDirection: "row" },
  container: { height: "100%", padding: 10 },
  dateText: { fontFamily: typography.primary.normal, fontSize: 12, marginLeft: 5 },
  description: { fontFamily: typography.primary.normal, marginTop: 10 },
  dividerView: {
    borderColor: colors.lightGrey,
    borderRadius: 1,
    borderStyle: "dashed",
    borderWidth: 1,
    height: 1,
    marginVertical: 20,
    width: "100%",
    zIndex: 1,
  },
  dividerViewStyle: {
    backgroundColor: colors.white,
    bottom: 0,
    height: 1,
    left: 0,
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  dontClickText: { color: colors.darkerGrey, marginBottom: 10, textAlign: "center" },
  flex: { flex: 1 },
  headerLeftButton: {
    alignItems: "center",
    backgroundColor: colors.lightGrey,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    left: 10,
    position: "absolute",
    top: 30,
    width: 40,
    zIndex: 99,
  },
  headerRightButton: {
    alignItems: "center",
    backgroundColor: colors.lightGrey,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    position: "absolute",
    right: 10,
    top: 10,
    width: 40,
    zIndex: 99,
  },
  image: { width: "100%" },
  modalContainer: {
    alignItems: "center",
    backgroundColor: colors.white,
    borderRadius: 20,
    padding: 20,
    maxWidth: 500,
    width: "90%",
    alignSelf: "center",
    flexShrink: 1,
  },
  mt30: { marginTop: 30 },
  qrExpiredText: { marginTop: 10, textAlign: "center", width: "80%" },
  qrText: { textAlign: "center", width: "80%" },
  redeemLaterButton: {
    borderWidth: 1,
    flex: 1,
    marginRight: 20,
    backgroundColor: "transparent",
    borderColor: "#e0070f",
  },
  redeemModalContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    width: "100%",
  },
  scrollContent: { paddingBottom: 100 },
  stickyBottomContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    bottom: 0,
    elevation: 1,
    justifyContent: "center",
    paddingBottom: 20,
    padding: 10,
    position: "absolute",
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    width: "100%",
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 20,
    marginBottom: 10,
    marginTop: 5,
  },
  usedExpiredText: { color: colors.lightGrey, padding: 10, textAlign: "center" },
  errorContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 5,
    minHeight: 22,
    marginBottom: 5,
    width: "100%", // Make the error container span the modal's width
    paddingHorizontal: 5, // Optional: Add slight padding if text bumps edges
  },
  errorIcon: {
    marginRight: 5,
  },
  errorText: {
    color: "red",
    flexShrink: 10,
    flex: 1,
  },
  // old new bal modal
  oldNewBalContainer: {
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 24,
    padding: 10,
    width: "100%",
    alignSelf: "center",
    elevation: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
  },
  balanceRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 12
  },
  balanceLabelNew: {
    fontSize: 13,
    fontWeight: '500',
    color: '#374151',
  },
  balanceValueNew: {
    fontSize: 13,
    fontWeight: '600',
    color: '#111827',
  },
  balanceLabelOld: {
    fontSize: 13,
    color: '#9CA3AF',
  },
  balanceValueOld: {
    fontSize: 13,
    color: '#9CA3AF',
  },
})
